/**
 * 🧱 Refactor BT Phase 3 — section « SectionLavagePressionCreer » de CreerBonTravailDialog.jsx : JSX déplacé TEL QUEL (ex-L1082-1141, dédenté de 10) ;
 * variables via `useBTForm()` (BTFormProvider enrichi par `extra`). DOM, data-testid, classes, textes inchangés.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { useBTForm } from '../../BTFormContext';

export function SectionLavagePressionCreer() {
  const {
    form,
    isExt,
    setForm,
    type,
  } = useBTForm();
  return (
    <>
      {/* Lavage à pression à faire (extérieur seulement) */}
      {isExt && (
        <Card className="border-blue-200">
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>
              Lavage à pression à faire
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={form.lavage_pression.necessaire} 
                onChange={e => setForm(f => ({...f, lavage_pression: {...f.lavage_pression, necessaire: e.target.checked}}))}
                className="w-4 h-4 rounded border-blue-300 text-blue-600" 
              />
              <span className="text-sm font-medium text-slate-700">Lavage à pression nécessaire</span>
            </label>

            {form.lavage_pression.necessaire && (
              <div className="pl-6 space-y-3 border-l-2 border-blue-200">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={form.lavage_pression.echafauds_a_monter} 
                    onChange={e => {
                      const checked = e.target.checked;
                      setForm(f => ({
                        ...f, 
                        lavage_pression: {...f.lavage_pression, echafauds_a_monter: checked},
                        echafaudages: {
                          ...f.echafaudages,
                          actif: checked,
                          source: checked ? 'lavage' : (f.echafaudages.source === 'lavage' ? '' : f.echafaudages.source),
                          date_montage: checked ? (f.dates_chantier[0] || '') : f.echafaudages.date_montage,
                        }
                      }));
                    }}
                    className="w-4 h-4 rounded border-orange-300 text-orange-600" 
                  />
                  <span className="text-sm font-medium text-orange-700">Échafauds à monter</span>
                </label>

                <div>
                  <Label className="text-xs">Notes sur le lavage</Label>
                  <Textarea 
                    value={form.lavage_pression.notes} 
                    onChange={e => setForm(f => ({...f, lavage_pression: {...f.lavage_pression, notes: e.target.value}}))}
                    rows={2}
                    placeholder="Instructions spéciales pour le lavage à pression..."
                    className="mt-1 text-sm"
                  />
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      )}

    </>
  );
}
